import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import './OtpPage.scss';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import TextInput from '../../../../Shared/TextInput/TextInput';
import Config from '../../../../../Config';
import { validateField, validateForm } from '../../../../../utilities/validation/formValidation';
import { goToPageWithoutHistory, setLoginDetails, reportDWH } from '../../EsimUpgradeBlockSlice';
import { createOtpAsync, isRestrictedCodeRequired } from '../../EsimUpgradeBlockAsyncThunk';
import { gtag4 } from '../../../../../utilities/analytics/tracking';

const OtpPage = (props) => {
    const [formData, setFormData] = useState({
        subscriberNo: { value: '', error: '', validationRules: { required: true, requiredMessage: 'נא הזן מספר טלפון', regexName: 'phoneRegex', regexMessage: 'מספר טלפון לא תקין' } }
    });
    const [createOtpError, setCreateOtpError] = useState('');

    useEffect(() => {
        gtag4({ event: 'EsimUpgrade_Step1_PhoneOtpPage', step: '1', action: 'PhoneOtpPage' });
        props.reportDWH({ actionType: 'OTP Page Step', status: 'Ongoing', messageText: 'Entered OTP Page Step1' });
    }, []);

    return (
        <div className='esim-upgrade-otp-page-wrapper'>
            <div className='esim-upgrade-otp-page'>
                <div className='main-icon-otp'>
                    <img
                        src={Config.epiBaseUrl + props.otpTopIcon}
                        alt=''
                    />
                </div>

                <div className='page-titles'>
                    <div className='title'>{props.otpPhoneTitle}</div>
                    <div className='sub-title'>{props.otpPhoneSubTitle}</div>
                </div>

                <div className='field-wrapper'>
                    <TextInput
                        value={formData.subscriberNo.value}
                        error={formData.subscriberNo.error}
                        placeholder='מה מספר הטלפון שלך?'
                        id='subscriberNo'
                        name='subscriberNo'
                        type='tel'
                        disabled=''
                        required='required'
                        maxLength='10'
                        autoComplete='off'
                        onChange={(e) => handleOnChange('subscriberNo', e.target.value)}
                    />
                </div>

                <div className='button-wrapper'>
                    <BtnSubmit
                        isBusiness={false}
                        text='בואו נתקדם'
                        onclick={handlePageContinue}
                        formid='esim-block'
                        isDisplayArrows={false}
                        isDisplayWhatsAppIcon={false}
                    />
                </div>

                {createOtpError && <div className='create-otp-error'>{createOtpError}</div>}
            </div>
        </div>
    );

    function handleOnChange(fieldName, value) {
        let data = formData;
        const error = validateField(data[fieldName].validationRules, value);
        data[fieldName].error = error;
        data[fieldName].value = value;
        setFormData({ ...data });
    }

    async function handlePageContinue() {
        setCreateOtpError('');

        const result = validateForm(formData);
        setFormData({ ...result.form });
        if (!result.isValid) { return; }

        gtag4({ event: 'EsimUpgrade_Step1_PhoneOtpButton', step: '1', action: 'PhoneOtpButton' });
        props.reportDWH({ actionType: 'OTP Page Step1', status: 'Ongoing', messageText: 'OTP Page Step1 Button Clicked' });

        const res = await props.createOtpAsync({ subscriberNo: formData.subscriberNo.value, isVoice: false });

        if (!res?.payload) {
            setCreateOtpError('אירעה שגיאה, אנא נסה שוב.');
            props.reportDWH({ actionType: 'OTP Page Step1', status: 'Error', messageText: 'General Error' });
            return;
        }

        const otpTicketId = res.payload.Body.message;
        props.setLoginDetails({
            subscriberNo: formData.subscriberNo.value,
            otpTicketId: otpTicketId,
            restrictedCodeRequired: isRestrictedCodeRequired(res.payload.Body),
        });
        props.goToPageWithoutHistory('validateOtpPage');
    }
};

const mapStateToProps = (state) => {
    return {
        otpTopIcon: state.esimUpgradeBlock.esimBlockData.otpTopIcon,
        otpPhoneTitle: state.esimUpgradeBlock.esimBlockData.otpPhoneTitle,
        otpPhoneSubTitle: state.esimUpgradeBlock.esimBlockData.otpPhoneSubTitle,
        otpRecievedCodeIcon: state.esimUpgradeBlock.esimBlockData.otpRecievedCodeIcon,
    };
};

const mapDispatchToProps = {
    goToPageWithoutHistory,
    createOtpAsync,
    setLoginDetails,
    reportDWH
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpPage);
